<template>
  <div
    class="wrapper"
    style="min-width: 100%; height: 100vh; background-color: #e5e5e5"
  >
    <!-- STATUS -->
    <div class="EntryError text-center" v-if="!isLoading">
      <div class="successMsg">
        <img src="@/assets/img/valid.svg" />
        Valid Booking
      </div>
    </div>

    <!-- MOVIE DETAILS -->
    <section
      class="movie_details_new"
      v-if="!isLoading && bookingDetails.sb_id"
    >
      <div class="movie_name_new padding-top">
        <h6>
          {{ bookingDetails.movie_title }}
          <span style="font-weight: 500">
            ({{ bookingDetails.version_name }})
          </span>
        </h6>
        <span class="dimension">{{ bookingDetails.mf_name }}</span>
      </div>

      <div class="second_section">
        <h5 class="font">{{ bookingDetails.show_time }}</h5>
        <img src="@/assets/img/Vertical.svg" class="img_vertical" />
        <h5 class="font">{{ bookingDetails.screen_name }}</h5>
      </div>
    </section>

    <!-- SEATS -->
    <section class="tickets_sec" v-if="!isLoading && bookingDetails.sb_id">
      <div class="content">
        <small class="text-muted">Seats</small>
        <span class="content-text">
          {{ bookingDetails.seats.join(", ") }}
          ({{ bookingDetails.seats.length }})
        </span>
        <span>
          <b>Total Amount:</b> <b>{{ bookingDetails.sb_total_amount }}</b></span
        >
      </div>

      <!-- SEAT SELECTION -->
      <div class="btn_count_wrapper">
        <button
          class="btn-count"
          :class="isAllSelected ? 'selected' : ''"
          @click="selectAllSeats"
        >
          All
        </button>

        <button
          v-for="seat in seats"
          :key="seat.ssb_id"
          class="btn-count"
          :class="seat.selected ? 'selected' : ''"
          @click="toggleSeat(seat)"
        >
          {{ seat.sl_seat_name }}
        </button>
      </div>

      <!-- PRINT BUTTON -->
      <div class="btn_check_main">
        <button
          class="btn-scan btn-confirm check_btn"
          :disabled="!hasSelection || disableConfirmed"
          @click="printSelectedSeats"
        >
          Re-Print
        </button>
      </div>
    </section>

    <section>
      <center>
        <footer class="footer">
          <div class="footer-sec">
            <div class="mx-4" @click="goToShow()">
              <img src="@/assets/img/reel.svg" />
            </div>

            <div class="mx-4" @click="goHome()">
              <img src="@/assets/img/scanner.svg" />
            </div>

            <div class="mx-4" @click="onLogout">
              <img src="@/assets/img/logout.svg" />
            </div>
          </div>
        </footer>
      </center>
    </section>
    <!-- PRINT HTML -->
    <div class="d-none" ref="print_boxoffice_fnb_ticket">
      <div v-html="EjsData"></div>
    </div>
  </div>
</template>

<script>
import BookingService from "@/services/BookingService";
import Printd from "printd";
import { URL_BASE as BASEURL } from "@/helper/constants";

export default {
  name: "TicketDetails",

  data() {
    return {
      bookingDetails: {},
      seats: [],
      qrcode: "",
      isLoading: false,
      disableConfirmed: false,
      EjsData: null,
    };
  },

  computed: {
    hasSelection() {
      return this.seats.some((s) => s.selected);
    },
    isAllSelected() {
      return (
        this.seats.length > 0 && this.seats.every((s) => s.selected === true)
      );
    },
    isMifClient() {
      const clientName = window.localStorage.getItem("CLIENT_NAME");
      return clientName.toLowerCase() === "mif";
    },
  },

  beforeMount() {
    let code = String(this.$route.query.qrcode || "");
    if (code.includes("http")) {
      code = code.split("/").pop();
    }
    this.qrcode = code;

    if (this.qrcode) {
      this.getBookingDetails(this.qrcode);
    } else {
      this.$router.go(-1);
    }
  },

  methods: {
    goToShow() {
      this.$router.push({
        name: "showtime",
        path: "/showtime",
      });
    },
    goHome: function() {
      this.$router.push({
        name: "qrCode",
      });
    },
    onLogout() {
      window.localStorage.removeItem("JWT_TOKEN");
      window.localStorage.removeItem("USERCINEINFO");
      window.localStorage.clear();
      this.$cookie.delete("BRHSID");
      this.$router.push({
        name: "login",
      });
      return window.caches.keys();
    },
    /* ================= BOOKING DETAILS ================= */

    getBookingDetails(bookingCode) {
      let loader = this.$loading.show();
      this.isLoading = true;

      BookingService.getWebsitePosBookingDetails({
        booking_code: bookingCode,
      })
        .then((res) => {
          const data = res.data;

          if (data.Records.length > 0) {
            this.bookingDetails = data.Records[0];
            // console.log("this.bookingDetails :", data.Records[0]);
            this.seats = (this.bookingDetails.selectedSeats || []).map(
              (seat) => ({
                ...seat,
                selected: false,
              })
            );
          } else {
            this.$toasted.show("No booking found");
          }
        })
        .catch(() => {
          this.$toasted.show("Failed to load booking");
          this.$router.go(-1);
        })
        .finally(() => {
          this.isLoading = false;
          loader.hide();
        });
    },

    /* ================= SEAT LOGIC ================= */

    toggleSeat(seat) {
      seat.selected = !seat.selected;
    },

    selectAllSeats() {
      const select = !this.isAllSelected;
      this.seats = this.seats.map((seat) => ({
        ...seat,
        selected: select,
      }));
    },

    REPRINT_COUNT_API: async function() {
      let cinemaId = window.localStorage.getItem("USERCINEINFO");
      let userInfo = JSON.parse(window.localStorage.getItem("USER_INFO"));

      if (this.isMifClient) {
        let result = await BookingService.CHECK_LIMIT_REPRINT({
          sb_id: this.bookingDetails.sb_id,
          trd_ft_id: this.bookingDetails.ft_id,
          cinema_id: cinemaId,
          pos_user_logged_in_username: userInfo.username,
          pos_user_logged_in_userId: userInfo.user_id,
          auth_by_logged_in_userId: userInfo.user_id,
          role_id: userInfo.role_id,
          role_name: userInfo.role_name,
        });
        // console.log("newAuth", this.authByReprint);

        return result.data.status;
      } else {
        return true;
      }
    },
    /* ================= PRINT LOGIC (UNCHANGED AS REQUESTED) ================= */

    async printSelectedSeats() {
      this.disableConfirmed = true;
      var checkReprint = await this.REPRINT_COUNT_API();
      const userAgent = navigator.userAgent.toLowerCase();
      const sb_id = this.bookingDetails.sb_id;
      const ft_id = this.bookingDetails.ft_id;

      const selectedSeats = this.seats.filter((s) => s.selected);
      const ssbIdsArray = selectedSeats.map((s) => s.ssb_id).join(",");

      const enteredType = selectedSeats.length === this.seats.length ? 1 : 2;
      if (checkReprint) {
        if (userAgent.indexOf(" electron/") > -1) {
          try {
            this.$socket.emit("on_print_ticket", {
              ttype: "dynamicURL",
              dataURL: `${BASEURL}/api/print-bo-fnb-ticket/${sb_id}/${ft_id}?ticket_print_type=${null}&print_taken_type=SCAN&ssbIdsArray=${ssbIdsArray}&enteredtype=${enteredType}`,
            });
          } catch (error) {
            console.log(error, "from common api ticket");
          }
        } else {
          try {
            const response = await BookingService.getBoFnbSingleTicketApi({
              sb_id,
              ft_id,
              ticket_print_type: null,
              ssbIdsArray,
              enteredType,
            });

            const { data } = response;
            if (data) {
              this.EjsData = data;
            }

            this.$nextTick(() => {
              const p = new Printd();
              p.print(this.$refs.print_boxoffice_fnb_ticket, []);
            });
          } catch (error) {
            console.log(error, "from common api ticket webb");
          }
        }
      } else {
        this.$toasted.show("Exhaust Limit Of Reprint");
      }

      this.disableConfirmed = false;
    },
  },
};
</script>

<style scoped>
.ratingAge {
  margin-bottom: 10px !important;
  font-size: 16px !important;
  padding: 6px !important;
  width: 100%;
}

.EntryError {
  /*margin-top: 40px;*/
  color: white;
  font-weight: bold;
  font-size: 20px;
  /*padding: 5px;*/
}

.EntryError .errorMsg {
  background-color: red;
  padding: 6px;
}

.EntryError .successMsg {
  background-color: green;
  padding: 6px;
}

.private-show-btn {
  background-color: #f2c94c;
}

.h-50 {
  height: 50px !important;
}

.w-60 {
  width: 60px !important;
}

.plus-minus-btn {
  background-color: #fff;
  border: 1px solid #3876d2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 35px;
  padding: 0 10px;
  height: 40px;
  flex: 0 0 auto;
  width: 40px;
  margin: 0 15px;
  border-radius: 8px;
  color: #3876d2;
}
.movie_details_new {
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.1);
  margin: 10px;
  /*padding: 12px;*/
}
.movie_name_new {
  text-align: center;
  border-bottom: 1px solid #e7e7e7;
  white-space: break-spaces;
  padding-bottom: 10px;
}
.movie_name_new h6 {
  font-weight: bold;
  text-transform: uppercase;
}
.second_section {
  /*display: flex;
  justify-content: space-around;
  align-items: center;*/
  display: flex; /*grid */
  /* grid-template-columns: 100px 10px 100px; */
  justify-content: space-between;
  /* text-align: center; */
  padding: 0 45px;
}
.font {
  font-size: 25px;
  font-weight: bold;
}
.padding-top {
  padding-top: 10px;
}
.img_vertical {
  background: #e7e7e7;
}
.tickets_sec {
  /*display: flex;*/
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.1);
  margin: 10px;
}
.content {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 10px;
}
.content-text {
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
}
.btn_check_main {
  display: flex;
  justify-content: center;
  align-content: center;
}
.check_btn {
  color: white;
  text-transform: uppercase;
  background-color: #032d6e;
  border: none;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding: 15px;
  width: 100%;
  text-transform: uppercase;
  font-weight: 700;
  align-items: center;
  justify-content: center;
  display: flex;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.footer-sec {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  background-color: white;
  padding: 10px;
  width: 100%;
  position: fixed;
  bottom: 0;
}
.age-circle {
  border: 3px solid black;
  background-color: yellow;
  color: black;
  border-radius: 50%;
  padding: 10px 30px;
  text-align: center;
}
.dob {
  font-weight: bold;
  text-transform: uppercase;
  margin-top: 10px;
  font-size: 17px;
}
.age-rating-new {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-bottom: 60px;
  background-color: rgb(229, 229, 229);
}
.instruction {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.dimension {
  background-color: black;
  color: white;
  font-weight: 700;
  text-transform: uppercase;
  padding: 3px 13px;
  font-size: 12px;
}

.seat-disabled {
  pointer-events: none;
  opacity: 0.5;
}

.instruction p {
  color: black;
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/reprintDetails.vue